export let SPACINGS_AFTER = /*#__PURE__*/function (SPACINGS_AFTER) {
  SPACINGS_AFTER["NONE"] = "none";
  SPACINGS_AFTER["SMALLEST"] = "smallest";
  SPACINGS_AFTER["SMALL"] = "small";
  SPACINGS_AFTER["NORMAL"] = "normal";
  SPACINGS_AFTER["MEDIUM"] = "medium";
  SPACINGS_AFTER["LARGE"] = "large";
  SPACINGS_AFTER["LARGEST"] = "largest";
  return SPACINGS_AFTER;
}({});